import { CostEstimation } from "../../project-plan/ProjectPlanPageState";

export type InputCostEstimationDialogState = {
  isShow: boolean;
  saved: CostEstimation;
  edited: CostEstimation;
  codes: {
    pjtBdgtAcqstnReqType?: Option[];
    statsOfAgreementOnBudgetaryType?: Option[];
  };
  fieldPath: FieldPath;
  pjtId: string;
  updateDateTime: string;
  status: {
    invalidList: string[];
    isSaved: boolean;
  };
};

export type Option = {
  label: string;
  value: string;
};

export type FieldPath = {
  pjtBdgtAcqstnReqTypeCd: string;
  statsOfAgreementOnBudgetaryTypeCd: string;
};

export type PageNewState =
  | InputCostEstimationDialogState
  | ((
      prevState: InputCostEstimationDialogState,
    ) => InputCostEstimationDialogState);
